const sortDates = (array) => {
  return array.sort(
    (eventA, eventB) =>
      new Date(eventA._event_start_date) - new Date(eventB._event_start_date)
  );
};

export { sortDates };
